module.exports = "/images/up-arrow-rev.svg?2f596d7de6979b5c4ce9574d93fde911";